/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/15/22
 */

import {gql} from "urql";
import {Calendar, CalendarConfig} from "../../interfaces/Global";

export const CreateSavedCalendarMutation = gql`
    mutation CreateSavedCalendar($data: SavedCalendarInput!) {
        createSavedCalendar(data: $data) {
            id
	        creationDate
	        createdBy
	        modifiedDate
	        modifiedBy
	        accessCount
            title
            config
	        vstamp
        }
    }
`;

export const UpdateSavedCalendarMutation = gql`
    mutation UpdateSavedCalendar($id: Int!, $data: SavedCalendarInput!) {
        updateSavedCalendar(id: $id, data: $data) {
            id
            creationDate
            createdBy
            modifiedDate
            modifiedBy
	        accessCount
            title
            config
	        vstamp
        }
    }
`;

export const DeleteSavedCalendarMutation = gql`
    mutation DeleteSavedCalendar($id: Int!) {
        deleteSavedCalendar(id: $id)
    }
`;

export interface DeleteSavedCalendarResponse {
	deleteSavedCalendar: boolean
}

export interface DeleteSavedCalendarVars {
	id: number
}

export interface CreateSavedCalendarResponse {
	createSavedCalendar: Calendar
}

export interface CreateSavedCalendarVars {
	data: SavedCalendarInput
}

export interface UpdateSavedCalendarResponse {
	updateSavedCalendar: Calendar
}

export interface UpdateSavedCalendarVars {
	id: number
	data: SavedCalendarInput
}

export interface SavedCalendarInput {
	title?: string
	isPublic?: boolean
	config?: CalendarConfig
}